/*
* Sets the preference for the customer type from the logged in user type
* This would prevent that a customer of type A sees the site as customer type B
*/
if (window.loggedInCustomerType) {
  window.localStorage.setItem('ls.biribox.view-type', window.loggedInCustomerType);
}

document.addEventListener('DOMContentLoaded', function() {
  /*
   * Open customer type selector modal if preference is not set
   * If set show the correct content for the customer type
   */
  let customerType = window.localStorage.getItem('ls.biribox.view-type');
  if (!customerType) {
    document.getElementById('overlay-buyer').style.display = 'block';
  } else {
    showCustomerTypeContent(customerType)
  }
  
  /*
   * Open customer type selector modal if preference is not set
   * If set show the correct content for the customer type
   */
  document.querySelectorAll('.type-user').forEach(element => {
    element.addEventListener('click', (evt) => {
      const customerType = evt.target.dataset.option;
  
      window.localStorage.setItem('ls.biribox.view-type', customerType);
      document.getElementById('overlay-buyer').style.display = 'none';
      
      showCustomerTypeContent(customerType)

      document.dispatchEvent(new CustomEvent("biribox:customer-type-changed", {
        detail: {
          componentId: '',
          customerType
        }
      }));
    });
  });
});


/*! (c) Andrea Giammarchi - ISC */
// https://github.com/WebReflection/html-parsed-element
// Class to handle the parsed state of a custom element.  Necessary to allow accesing child elements when inicializing customm elements.
const HTMLParsedElement = (() => {
  const DCL = 'DOMContentLoaded';
  const init = new WeakMap;
  const queue = [];
  const isParsed = el => {
    do {
      if (el.nextSibling)
        return true;
    } while (el = el.parentNode);
    return false;
  };
  const upgrade = () => {
    queue.splice(0).forEach(info => {
      if (init.get(info[0]) !== true) {
        init.set(info[0], true);
        info[0][info[1]]();
      }
    });
  };
  document.addEventListener(DCL, upgrade);
  class HTMLParsedElement extends HTMLElement {
    static withParsedCallback(Class, name = 'parsed') {
      const {prototype} = Class;
      const {connectedCallback} = prototype;
      const method = name + 'Callback';
      const cleanUp = (el, observer, ownerDocument, onDCL) => {
        observer.disconnect();
        ownerDocument.removeEventListener(DCL, onDCL);
        parsedCallback(el);
      };
      const parsedCallback = el => {
        if (!queue.length)
          requestAnimationFrame(upgrade);
        queue.push([el, method]);
      };
      Object.defineProperties(
        prototype,
        {
          connectedCallback: {
            configurable: true,
            writable: true,
            value() {
              if (connectedCallback)
                connectedCallback.apply(this, arguments);
              if (method in this && !init.has(this)) {
                const self = this;
                const {ownerDocument} = self;
                init.set(self, false);
                if (ownerDocument.readyState === 'complete' || isParsed(self))
                  parsedCallback(self);
                else {
                  const onDCL = () => cleanUp(self, observer, ownerDocument, onDCL);
                  ownerDocument.addEventListener(DCL, onDCL);
                  const observer = new MutationObserver(() => {
                    /* istanbul ignore else */
                    if (isParsed(self))
                      cleanUp(self, observer, ownerDocument, onDCL);
                  });
                  observer.observe(self.parentNode, {childList: true, subtree: true});
                }
              }
            }
          },
          [name]: {
            configurable: true,
            get() {
              return init.get(this) === true;
            }
          }
        }
      );
      return Class;
    }
  }
  return HTMLParsedElement.withParsedCallback(HTMLParsedElement);
})();

// Create a Toggle switch Web Component
// Improve
class CustomerTypeSelector extends HTMLParsedElement {

  constructor() {
    super();

    this.componentId = this.generateRandomId(8);

    this.addEventListener('change', this.handleChange.bind(this));

    document.addEventListener("biribox:customer-type-changed", (event) => {
      this.setSavedValue();

      if (event.detail.componentId !== this.componentId && this.dataset.isRegister == 'true') {
        this.customerType = event.detail.customerType;
        this.toggleCustomerType(this.customerType);
      }
    });
    
    this.customerType = null;
    this.formVisible = false;
  }

  parsedCallback() {
    this.errorMessageElement = this.querySelector('[data-error-message]');

    if (this.dataset.setInitialValue !== 'false') {
      this.setSavedValue();
    }

    this.continueBtn = this.querySelector('[data-continue-btn]');
    if (this.continueBtn) {
      this.continueBtn.addEventListener('click', this.buttonHandle.bind(this));
    }
  
    this.errorMessage = this.dataset.errorMessage || 'Please select a customer type';
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
    document.removeEventListener("biribox:customer-type-changed", this.setSavedValue);
  }

  handleChange(event) {

    if (!event.target.hasAttribute('data-customer-type-radio')) {
      return;
    }

    this.customerType = event.target.value;

    if (window.loggedInCustomerType && this.customerType !== window.loggedInCustomerType) {
      alert(this.dataset.changeErrorMessage);
      this.setSavedValue();
      return;
    }

    this.toggleCustomerType(this.customerType);
  }

  toggleCustomerType(customerType) {
    window.localStorage.setItem('ls.biribox.view-type', customerType);

    showCustomerTypeContent(customerType);

    // document.dispatchEvent(new Event("biribox:customer-type-changed"));
    document.dispatchEvent(new CustomEvent("biribox:customer-type-changed", {
      detail: {
        componentId: this.componentId,
        customerType
      }
    }));

    if (this.continueBtn) {
      this.continueBtn.classList.remove('disabled');
    }

    if (this.formVisible) {
      this.showSelectedForm();
    }
  }

  setSavedValue() {
    const initialValue = window.localStorage.getItem('ls.biribox.view-type') || 'private';
    const field = this.querySelector(`input[type="radio"][value="${initialValue}"]`);

    // usar variables de css y evitar los style inline
    if (initialValue == 'private') {
      document.body.style.setProperty('--price-b2c-display', 'block')
      document.body.style.setProperty('--price-b2b-display', 'none')
    } else if (initialValue == 'business') {
      document.body.style.setProperty('--price-b2c-display', 'none')
      document.body.style.setProperty('--price-b2b-display', 'block')
    }

    if (!field) return false;
    field.checked = true;
  }

  buttonHandle() {
    if (this.customerType) {
      this.showSelectedForm();   
    } else {
      this.errorMessageElement.innerHTML = this.errorMessage;
    }
  }

  showSelectedForm() {
    this.querySelectorAll(`form[data-customer-type-form]`).forEach((form) => {
      form.style.display = 'none';
    });

    const form = this.querySelector(`form[data-customer-type-form="${this.customerType}"]`);
    if (form) {
      form.style.display = 'block';
      this.querySelector('[data-continue-wrap]').style.display = 'none';
      this.formVisible = true;
    } 
  }

  generateRandomId(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}

customElements.define('customer-type-selector', CustomerTypeSelector);
